import { FC } from "react";

import { GetAnimalsList_animalsExtended_animals } from "api/MyLivestock/Animal/types/GetAnimalsList";

import { Close, Checked } from "constants/SvgIcons";

import styles from "./styles.module.scss";

interface Props {
  allAnimalsCount: number;
  animalsCanBeRemove: GetAnimalsList_animalsExtended_animals[];
  animalsCouldNotRemove: GetAnimalsList_animalsExtended_animals[];
}

const BulkMoveOffFarm: FC<Props> = ({ allAnimalsCount, animalsCanBeRemove, animalsCouldNotRemove }) => (
  <div className={styles.container}>
    <span className={styles.infoText}>{`${allAnimalsCount} animals were selected to be moved off-farm`}</span>
    <span className={styles.infoSuccessText}>{`${animalsCanBeRemove.length} animals will be moved off-farms`}</span>
    <span className={styles.infoDangerText}>
      {`${animalsCouldNotRemove.length} animals are unable to be moved off-farm`}
    </span>
    <div className={styles.listContainer}>
      {[...animalsCouldNotRemove, ...animalsCanBeRemove].map((animal) => (
        <div key={animal.id} className={styles.itemBlock}>
          <div className={styles.passportNumberBlock}>
            <span className={styles.animalDataText}>{`${animal.visualId ? `${animal.visualId} | ` : ""}${
              animal.passportNumber || ""
            }`}</span>
          </div>
          <div className={styles.statusBlock}>
            {animal.rflId ? <Close nativeColor="#8C1C2F" /> : <Checked nativeColor="#51A667" />}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default BulkMoveOffFarm;
